(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["workshop-tabs"] && !Shopify.designMode) return;
  try {
    

const tabLinks = document.querySelectorAll('.tab-menu li a');
const lineSvgWorkshops = document.querySelectorAll('.line-svg-workshop');

// Hide all line-svg-workshop elements except the first one
lineSvgWorkshops.forEach((lineSvg, index) => {
  if (index !== 0) {
    lineSvg.style.display = 'none';
  }
});

tabLinks.forEach((link, index) => {
  link.addEventListener('click', (event) => {
    event.preventDefault();
    const target = link.getAttribute('data-rel');
    tabLinks.forEach(link => link.classList.remove('active'));
    link.classList.add('active');

    const targetContent = document.querySelector(`#${target}`);
    const tabContents = document.querySelectorAll('.tab-box');

    tabContents.forEach((content, index) => {
      if (content === targetContent) {
        content.style.display = 'block';
        lineSvgWorkshops[index].style.display = 'block'; // Show corresponding line-svg-workshop
      } else {
        content.style.display = 'none';
        lineSvgWorkshops[index].style.display = 'none'; // Hide line-svg-workshop
      }
    });
  });
});




  } catch(e) { console.error(e); }
})();
})();
